import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";

import * as Template from "../../templates";
import { update, list } from "../../actions";
import { Row, Col } from "react-bootstrap";

import EditorField from "../../templates/modules/forms/Editor";

const K_WIDTH = 40;
const K_HEIGHT = 40;
const greatPlaceStyle = {
  position: "absolute",
  width: K_WIDTH,
  height: K_HEIGHT,
  left: -K_WIDTH / 2,
  top: -K_HEIGHT / 2,
  textAlign: "center",
  color: "#f0643b",
  fontSize: "40px",
  padding: 4,
};

const AnyReactComponent = ({ text }) => (
  <div style={greatPlaceStyle}>{text}</div>
);

export default () => {
  const moduleName = `contacts`;
  const zoom = 18;
  const appReducer = useSelector((state) => state.appReducer, shallowEqual);
  const dispatch = useDispatch();

  const [id, setId] = useState(0);
  const [about, setAbout] = useState(``);
  const [contact, setContact] = useState(``);
  const [address, setAddress] = useState(``);
  const [instagram, setInstagram] = useState(``);
  const [whatsapp, setWhatsapp] = useState(``);
  const [telegram, setTelegram] = useState(``);
  const [zipcode, setZipcode] = useState(``);
  const [center, setCenter] = useState({
    lat: 35.74350813350205,
    lng: 51.55670280450745,
  });

  const handleClick = () => dispatch(update(id, moduleName));
  const handleAboutChange = (value) => setAbout(value);
  const handleContactChange = (value) => setContact(value);
  const onPlaceChanged = (option) =>
    setCenter({
      lat: option.lat,
      lng: option.lng,
    });

  useEffect(() => {
    if (appReducer.contacts_list != undefined) {
      let row = appReducer.contacts_list.data;
      if (row != undefined) {
        setId(row.id);
        setAbout(row.about);
        setContact(row.contact);
        setCenter({
          lat: row.latitude,
          lng: row.longitude,
        });
        setAddress(row.address);
        setInstagram(row.instagram);
        setWhatsapp(row.whatsapp);
        setTelegram(row.telegram);
        setZipcode(row.zipcode);
      }
    }
  }, [appReducer.contacts_list]);

  useEffect(() => {
    dispatch(list(moduleName));
  }, []);

  return (
    <Template.Form>
      <div>

        <EditorField
          label="درباره ما"
          onEditorChange={handleAboutChange}
          value={about}
        />

        <input name="about" type="hidden" defaultValue={about} />
      </div>
      <div>
        <EditorField
          label="اطلاعات تماس"
          onEditorChange={handleContactChange}
          value={contact}
        />
        <input name="contact" type="hidden" defaultValue={contact} />
      </div>
      <Row>
        <Col xs={12} sm={12} lg={4} md={4}>
          <Template.Input
            mb={3}
            value={instagram}
            label="اینستاگرام"
            className="ltr"
            name="instagram"
            type="text"
          />
        </Col>
        <Col xs={12} sm={12} lg={4} md={4}>
          <Template.Input
            mb={3}
            value={whatsapp}
            label="واتساپ"
            className="ltr"
            name="whatsapp"
            type="text"
          />
        </Col>
        <Col xs={12} sm={12} lg={4} md={4}>
          <Template.Input
            mb={3}
            value={telegram}
            label="تلگرام"
            className="ltr"
            name="telegram"
            type="text"
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12} sm={12} lg={6} md={6}>
          <Template.Input
            mb={3}
            value={address}
            label="آدرس"
            name="address"
            type="text"
          />
        </Col>
        <Col xs={12} sm={12} lg={6} md={6}>
          <Template.Input
            mb={3}
            value={zipcode}
            label="کدپستی"
            className="ltr"
            name="zipcode"
            type="text"
          />
        </Col>
      </Row>
    
      <input type="hidden" name="latitude" defaultValue={center.lat} />

      <input type="hidden" name="longitude" defaultValue={center.lng} />

      <Template.Button label="ذخیره"  onClick={handleClick} />
    </Template.Form>
  );
};
